<template>
    <HeroBanner/>
<AboutUs/>

<SpecialDishes/>



   <ServicesContent/>
    

 <TestimonialsContent/>


    <DividerComponent/>

    <ContactUs/>

   
</template>

<script>
import HeroBanner from '@/components/home/HeroBannerSection.vue';
import ContactUs from '@/components/home/ContactUsSection.vue';
import AboutUs from '@/components/home/HomeAbousUsSection.vue';
import TestimonialsContent from '@/components/home/TestimonialsContent.vue';
import SpecialDishes from '@/components/home/SpecialDishesSection.vue';
import DividerComponent from '@/components/DividerComponent.vue';
import ServicesContent from '@/components/home/ServicesContent.vue';
export default {
  name: 'HomePage',
   components: {
    AboutUs,
    ServicesContent,
    HeroBanner,
    TestimonialsContent,
    ContactUs,
    DividerComponent,
    SpecialDishes
  }
}
</script>

<style scoped>
.carousel-caption {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2rem;
  border-radius: 1rem;
}

/* Standardize images in cards */
.card-img-top {
  object-fit: cover;
  height: 200px;
}

/* Keep menu gallery images uniform */
.menu-gallery img {
  height: 180px;
  object-fit: cover;
  width: 100%;
  border-radius: 0.5rem;
}
</style>
